import { FreewheelModel } from 'tag/ts/tag/model/ads/freewheel/FreewheelModel';
import { AbstractAssetPlaybackUtility } from 'tag/ts/tag/player/adapters/avia/utilities/AbstractAssetPlaybackUtility';
import { FWUtilities } from 'tag/ts/tag/utilities/FWUtilities';
export class PIDPlaybackUtility extends AbstractAssetPlaybackUtility {
    constructor(argument) {
        super({
            name: 'PIDPlaybackUtility',
            ...argument
        });
    }
    getMediaUrl() {
        const fwModel = new FreewheelModel({ tag: this.tag });
        const fwUtil = FWUtilities.getInstance();
        const isIntl = this.isIntl();
        const videoAdsEnabled = this?.videoAdsEnabled();
        let mediaUrl;
        const millstoneStreamingUrl = this.tag?.millstoneUtilities?.getStreamingUrl();
        const apiMetadataStreamingUrl = this?.apiMetadata?.streamingUrl;
        if (this.utils?.URL?.valid(millstoneStreamingUrl)) {
            mediaUrl = millstoneStreamingUrl;
            this.logger?.log('getMediaUrl:', 'using streamingUrl from millstone:', mediaUrl);
        }
        else {
            mediaUrl = apiMetadataStreamingUrl;
            this.logger?.log('getMediaUrl:', 'millstone streamingUrl is invalid, fallback to apiMetadata streamingUrl:', mediaUrl);
        }
        if (!isIntl) {
            this.logger?.log('getMediaUrl:', 'is not INTL... will not add Freewheel parameters to mediaUrl');
        }
        if (!videoAdsEnabled) {
            this.logger?.log('getMediaUrl:', 'video ads disabled... will not add Freewheel parameters to mediaUrl');
        }
        if (isIntl && videoAdsEnabled) {
            mediaUrl = fwUtil.createFWUrl(fwModel, mediaUrl);
            this.logger?.log('getMediaUrl:', 'is INTL, video ads enabled... append Freewheel parameters to mediaUrl as query parameters:', mediaUrl);
        }
        this?.logger?.log('getMediaUrl:', 'returning url:', mediaUrl);
        return mediaUrl;
    }
}
